import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

//main module
import subscriptionModule from './subscriptionModule';

//main scss file
import '../../../css/subscription/subscription.scss';

//all other files that we want attached to the module.
importFilesUnderPath(require.context("./controllers/", true, /\.js$/));
importFilesUnderPath(require.context("./directives/", true, /\.js$/));
importFilesUnderPath(require.context("./constants/", true, /\.js$/));
importFilesUnderPath(require.context("./services/", true, /\.js$/));

// import all entry files
// premium
import premiumEntry from "../premium/premiumEntry.js";

//main module templates
const templateContext = require.context("./", true, /\.html$/);
const templates = templateCacheGenerator(angular, 'subscriptionHtmlTemplateApp', templateContext, null);

//self manual initialization
angular.element(function () {
    angular.bootstrap("#premium-page", [subscriptionModule.name, templates.name]);
});

export default subscriptionModule;